document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.slideshow')) {
    // Remove noscript elements
    var noscripts = document.querySelectorAll('.slideshow noscript');
    noscripts.forEach(function(noscript) {
      noscript.parentNode.removeChild(noscript);
    });

    // Initialize Flickity
    var sliders = document.querySelectorAll('.slideshow__main');
    sliders.forEach(function(slider) {
      var slides = slider.querySelectorAll('.slideshow__slide');
      if (slides.length > 1) {
        new Flickity(slider, {
          cellAlign: 'left',
          wrapAround: true,
          pageDots: false,
          autoPlay: slider.dataset.autoPlay === "true",
          accessibility: true,
          arrowShape: 'M11.6123 37.6519C20.5841 47.1865 42.5016 68.1563 42.5016 68.1563C42.5016 68.1563 42.5016 16.1722 42.5016 6.93406C42.5016 -2.31196 55.2618 -2.31192 55.2618 6.93406C55.2618 16.1704 55.2618 68.1563 55.2618 68.1563C55.2618 68.1563 74.4575 48.5612 86.1258 37.6519C93.0274 31.3854 101.313 40.6564 95.1635 46.6772C82.3981 59.0788 55.2618 87.9249 55.2618 87.9249C55.2618 87.9249 48.9314 94.2555 42.5016 87.9249C28.5782 73.9016 14.0731 57.7707 2.46347 46.6772C-4.49921 39.8266 4.78727 30.2705 11.6123 37.6519Z',
          on: {
            ready: function() {
              slides.forEach(slide => {
                const button = slide.querySelector('.button');
                if (slide.getAttribute('aria-hidden') === 'true') {
                  button.setAttribute('tabindex', '-1');
                } else {
                  button.removeAttribute('tabindex');
                }
              });
            },
            change: function() {
              slides.forEach(slide => {
                const button = slide.querySelector('.button');
                if (slide.getAttribute('aria-hidden') === 'true') {
                  button.setAttribute('tabindex', '-1');
                } else {
                  button.removeAttribute('tabindex');
                }
              });
            }
          }
        });
      }
    });
  };
});

document.addEventListener('shopify:section:load', function(event) {
  if (document.querySelector('.slideshow')) {
    // Remove noscript elements
    var noscripts = document.querySelectorAll('.slideshow noscript');
    noscripts.forEach(function(noscript) {
      noscript.parentNode.removeChild(noscript);
    });

    function initializeFlickity() {
      var section = document.getElementById(event.detail.sectionId);
      if (!section) {
        // If section is still undefined, retry after increasing timeout
        setTimeout(initializeFlickity, 100);
        return;
      }
    
      var sliders = section.querySelectorAll('.slideshow__main');
      sliders.forEach(function(slider) {
        var slides = slider.querySelectorAll('.slideshow__slide');
        // Check if Flickity instance exists, and destroy it first to reinitialize
        if (slider.flickityInstance && slides.length <= 1) {
          slider.flickityInstance.destroy();
        }
        if (slides.length > 1 && !slider.flickityInstance) {
          slider.flickityInstance = new Flickity(slider, {
            cellAlign: 'left',
            wrapAround: true,
            pageDots: false,
            autoPlay: slider.dataset.autoPlay === "true",
            accessibility: true,
            arrowShape: 'M11.6123 37.6519C20.5841 47.1865 42.5016 68.1563 42.5016 68.1563C42.5016 68.1563 42.5016 16.1722 42.5016 6.93406C42.5016 -2.31196 55.2618 -2.31192 55.2618 6.93406C55.2618 16.1704 55.2618 68.1563 55.2618 68.1563C55.2618 68.1563 74.4575 48.5612 86.1258 37.6519C93.0274 31.3854 101.313 40.6564 95.1635 46.6772C82.3981 59.0788 55.2618 87.9249 55.2618 87.9249C55.2618 87.9249 48.9314 94.2555 42.5016 87.9249C28.5782 73.9016 14.0731 57.7707 2.46347 46.6772C-4.49921 39.8266 4.78727 30.2705 11.6123 37.6519Z',
            on: {
              ready: function() {
                slides.forEach(slide => {
                  const button = slide.querySelector('.button');
                  if (slide.getAttribute('aria-hidden') === 'true') {
                    button.setAttribute('tabindex', '-1');
                  } else {
                    button.removeAttribute('tabindex');
                  }
                });
              },
              change: function() {
                slides.forEach(slide => {
                  const button = slide.querySelector('.button');
                  if (slide.getAttribute('aria-hidden') === 'true') {
                    button.setAttribute('tabindex', '-1');
                  } else {
                    button.removeAttribute('tabindex');
                  }
                });
              }
            }
          });
        }
      });
    }
    
    // Initial call with a timeout of 100ms
    setTimeout(initializeFlickity, 100);
  }
});
